import { render, staticRenderFns } from "./CompetitionAbout.vue?vue&type=template&id=5416a2d5&scoped=true"
import script from "./CompetitionAbout.vue?vue&type=script&lang=js"
export * from "./CompetitionAbout.vue?vue&type=script&lang=js"
import style0 from "./CompetitionAbout.vue?vue&type=style&index=0&id=5416a2d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5416a2d5",
  null
  
)

export default component.exports